export const collections = [
  { name: "Ant Design Icons", value: "ant-design" },
  { name: "Bootstrap Icons", value: "bi" },
  { name: "Boxicons", value: "bx" },
  { name: "Codicons", value: "codicon" },
  { name: "Feather Icons", value: "fe" },
  { name: "Font Awesome Solid", value: "fa6-solid" },
  { name: "Font Awesome Regular", value: "fa6-regular" },
  { name: "Heroicons", value: "heroicons" },
  { name: "Ionicons", value: "ion" },
  { name: "Lucide Icons", value: "lucide" },
  { name: "Material Design Icons", value: "mdi" },
  { name: "Octicons", value: "octicon" },
  { name: "Phosphor Icons", value: "ph" },
  { name: "Radix Icons", value: "radix-icons" },
  { name: "Remix Icons", value: "ri" },
  { name: "Tabler Icons", value: "tabler" },
  { name: "Typicons", value: "typcn" },
  { name: "VS Code Icons", value: "vscode-icons" },
  { name: "Weather Icons", value: "wi" },
  { name: "Zondicons", value: "zondicons" },
];
